import { Client, Account, OAuthProvider } from "appwrite";
import conf from "../conf/conf";

const client = new Client()
  .setEndpoint(conf.appwrite_url)
  .setProject(conf.appwrite_project_id);

export const account = new Account(client);

export const signup = async ({ email, password, name }) => {
  try {
    await account.create("unique()", email, password, name);

    // Create session only if not already logged in
    const currentUser = await account.get().catch(() => null);
    if (!currentUser) {
      await account.createEmailPasswordSession(email, password);
    }

    const user = await account.get();
    return { success: true, data: user };
  } catch (error) {
    return { success: false, message: error.message };
  }
};

export const login = async ({ email, password }) => {
  try {
    // 1. Check if user is already logged in
    const currentUser = await account.get().catch(() => null);

    if (!currentUser) {
      // 2. Only create session if no active session exists
      await account.createEmailPasswordSession(email, password);
    }

    // 3. Fetch user details
    const user = await account.get();
    return { success: true, data: user };
  } catch (error) {
    return { success: false, message: error.message };
  }
};

export const logout = async () => {
  try {
    await account.deleteSession("current");
    return { success: true };
  } catch (error) {
    return { success: false, message: error.message };
  }
};

export const getCurrentUser = async () => {
  try {
    const user = await account.get();
    return { success: true, data: user };
  } catch {
    return { success: false, data: null };
  }
};

export const loginWithGoogle = async () => {
  try {
    // Redirects user to Google OAuth page
    await account.createOAuth2Session(
      "google",
      "http://localhost:3000/oauth/callback", // success redirect
      "http://localhost:3000/login" // failure redirect
    );
  } catch (error) {
    console.error("OAuth Login Error:", error.message);
    return { success: false, message: error.message };
  }
};
